
import { Next, Route } from 'vue-router';
import { Component, Vue, Prop } from "vue-property-decorator";
import { Problem, IProblem } from "./IProblem";
import Bus from "@/lib/Bus"; const bus: Bus = new Bus().getBus(); 
import ProblemVue from "@/problem/Problem.vue";
import  ButtonVue from "@/lib/Button.vue";
import { ProblemSvc } from "./ProblemSvc"
import { IDevice } from '@/device/IDevice';
import { DeviceSvc } from '@/device/DeviceSvc';
import { IUser } from "@/../../server/src/user/IUser";


@Component({ async beforeRouteEnter(to: Route, from: Route, next: Next<ProblemsVue>) {
            console.log("********************* beforeRouteEnter:", to.path, to.params.device_id )
            next((vm: ProblemsVue) => { vm.device_id = to.params.device_id  });
        },
        components: { ButtonVue } 
        })

export default class ProblemsVue extends Vue {

  device_id:any;

  filter_device=false;
  device:IDevice|undefined=undefined;
  problemSvc=new ProblemSvc()
  deviceSvc=new DeviceSvc()
  problems:IProblem[] = []
  limit:number=99
  key=0;

  async refresh() {
    this.problems=[]

    if (this.device_id) {
      this.device=await this.deviceSvc.find_by_id(this.device_id)
      this.filter_device=true
    }

    const problems: IProblem[] = await this.problemSvc.get_problems_short(this.device_id, this.limit )
    this.problems=problems;
    console.log('problems', this.problems)
    this.key++
   
  }

  async show_problem(_id:string) {
      window.router.push({ path: `/problems/${_id}` }) 
  }

  async add_problem_problem(_id:string) {
      window.router.push({ path: `/problems/${_id}/problem` }) 
  }

  async mounted() {
    console.log('mounted ',this.$route.params)
    //const prj_id = this.$route.params.prj_id
    await this.refresh();
  }

  async create() {
    const problem=new Problem();
    const user:IUser=JSON.parse(bus.get_token()).user
    const problem_new = await this.problemSvc.create(this.device_id, user.data_username)

    if (problem_new && problem_new._id) {
      await this.show_problem(problem_new._id)
    }
    
  }

}
